import React, { useState } from 'react';
import { Container, Typography, Box, TextField, Button, Switch, FormControlLabel } from '@mui/material';
import './SettingsPage.css';

const SettingsPage = () => {
  const [email, setEmail] = useState('');
  const [bpsUser, setBpsUser] = useState('');
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleBpsUserChange = (event) => {
    setBpsUser(event.target.value);
  };

  const handleNotificationsChange = (event) => {
    setNotificationsEnabled(event.target.checked);
  };

  const handleSave = () => {
    // Logic to handle save action
    console.log('Settings saved:', { email, bpsUser, notificationsEnabled });
  };

  const handleCancel = () => {
    // Logic to handle cancel action
    setEmail('');
    setBpsUser('');
    setNotificationsEnabled(false);
  };

  return (
    <Container className="settings-container">
      <Box my={4}>
        <Typography variant="h4" gutterBottom className="settings-title">
          Configuración 
        </Typography>
        <Box mt={4}>
          <TextField
            label="Correo Electrónico"
            variant="outlined"
            fullWidth
            value={email}
            onChange={handleEmailChange}
          />
        </Box>
        <Box mt={4}>
          <TextField
            label="Usuario BPS"
            variant="outlined"
            fullWidth
            value={bpsUser}
            onChange={handleBpsUserChange}
          />
        </Box>
        <Box mt={4}>
          <FormControlLabel
            control={
              <Switch
                checked={notificationsEnabled}
                onChange={handleNotificationsChange}
                color="primary"
              />
            }
            label="Habilitar Notificaciones"
          />
        </Box>
        <Box mt={4} display="flex" justifyContent="space-between">
          <Button variant="contained" color="secondary" onClick={handleCancel}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={handleSave}>
            Guardar
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default SettingsPage;